var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loading)?_c('df-loading-mask'):_c('div',{staticClass:"df-page df-page-email-change"})
}
var staticRenderFns = []

export { render, staticRenderFns }